import { Badge, BadgeButton, BadgeProps } from "src/components/base/badges/base";
import React from "react";
import { Link } from "src/components/base/link";
import { XMarkIcon } from "@heroicons/react/16/solid";
import { useLocation } from "@tanstack/react-router";

export type TagBadgeProps = {
    /**
     * The tag this badge is for
     *
     * The type is intentionally not from the generated sdk
     * to support as many caller as possible
     */
    tag: { uuid: string; name: string; description?: string };

    /**
     * The badge's color
     *
     * This optional argument overwrites the default `"blue"`.
     */
    color?: BadgeProps["color"];

    /** Additional classname to set */
    className?: string;

    /**
     * A `<TagBadge />` is a link to the tag's page.
     * This optional argument overwrites this link's default target.
     */
    target?: "_blank" | "_parent" | "_self" | "_top";

    /**
     * Optional callback to invoke when the "x" is clicked.
     *
     * If this callback is not set, then no "x" will be rendered.
     */
    onRemove?: () => void;
};

export function TagBadge(props: TagBadgeProps) {
    const { className, color, tag, onRemove, target } = props;

    const location = useLocation();
    const href = location.href.startsWith("/c") ? "/c/tags/$tagId/associated" : "/a/tags/$tagId/associated";

    if (onRemove === undefined)
        return (
            <BadgeButton
                className={className}
                color={color ?? "blue"}
                title={tag.description}
                href={href}
                params={{ tagId: tag.uuid }}
                target={target}
            >
                {`tag:${tag.name}`}
            </BadgeButton>
        );
    else
        return (
            <Badge className={className} color={"blue"} title={tag.description}>
                <Link href={href} params={{ tagId: tag.uuid }} target={target}>{`tag:${tag.name}`}</Link>
                <button onClick={() => onRemove()}>
                    <XMarkIcon className={"size-4"} />
                </button>
            </Badge>
        );
}
